
define('tpl!ui/badge/tpl/badge', ['handlebars'], function(hb){ 
return hb.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  


  return "<div class=\"badge-component\">\n    <div class=\"loader\"></div>\n    <span class=\"badge-border\"></span>\n    <span class=\"badge\"></span>\n</div>";
  });
});

